import Cookies from "js-cookie";
import { storageSession } from "@pureadmin/utils";
import { useUserStoreHook } from "@/store/modules/user";
import { UserPermission } from "@/assets/data/permission";
import { useAuth } from '@/utils/authLogin'

const { setLogin } = useAuth()

export interface UserInfo {
  alias: string;
  createdAt: string;
  id: number;
  idcard: string;
  photo: string;
  role: number;
  status: number;
  tel: string;
  updatedAt: string;
  username: string;
  permission: UserPermission;
  roles: {
    name: string;
    id: number;
  };
}

export interface DataInfo<T = number> {
  /** token */
  accessToken: string;
  /** `accessToken`的过期时间（时间戳） */
  expires: T;
  /** 用于调用刷新accessToken的接口时所需的token */
  refreshToken: string;
  /** 用户名 */
  user?: UserInfo;
}

export const sessionKey = "user-info";
export const TokenKey = "authorized-token";

/** 获取`token` */
export function getToken(): DataInfo<number> {
  // 优先从 Cookie 读取（含 accessToken），Cookie 被清除时不要回退到 sessionStorage，
  // 因为 sessionStorage 中只存了 refreshToken/expires/user，没有 accessToken，
  return Cookies.get(TokenKey)
    ? JSON.parse(Cookies.get(TokenKey))
    : storageSession().getItem(sessionKey);
  // 直接返回会导致请求拦截器误判为已登录并触发有问题的 token 刷新流程。
  // const cookieToken = Cookies.get(TokenKey)
  //   ? JSON.parse(Cookies.get(TokenKey))
  //   : null;
  // if (cookieToken?.accessToken) return cookieToken;
  // const sessionToken = storageSession().getItem<DataInfo<number>>(sessionKey);
  // if (sessionToken?.accessToken) return sessionToken;
  // return undefined;
}

/**
 * @description 设置`token`以及一些必要信息并采用无感刷新`token`方案
 * 无感刷新：后端返回`accessToken`（访问接口使用的`token`）、`refreshToken`（用于调用刷新`accessToken`的接口时所需的`token`，`refreshToken`的过期时间（比如30天）应大于`accessToken`的过期时间（比如2小时））、`expires`（`accessToken`的过期时间）
 * 将`accessToken`、`expires`这两条信息放在key值为authorized-token的cookie里（过期自动销毁）
 * 将`username`、`refreshToken`、`expires`这四条信息放在key值为`user-info`的sessionStorage里（浏览器关闭自动销毁）
 */
export function setToken(data: DataInfo<Date>) {
  let expires = 0;
  const { accessToken, refreshToken } = data;
  expires = new Date(data.expires).getTime(); // 如果后端直接设置时间戳，将此处代码改为expires = data.expires，然后把上面的DataInfo<Date>改成DataInfo<number>即可
  const cookieString = JSON.stringify({ accessToken, expires });

  expires > 0
    ? Cookies.set(TokenKey, cookieString, {
      expires: (expires - Date.now()) / 86400000
    })
    : Cookies.set(TokenKey, cookieString);

  function setSessionKey(user: UserInfo) {
    useUserStoreHook().SET_USER(user);
    storageSession().setItem(sessionKey, {
      refreshToken,
      expires,
      user
    });
  }
  setLogin(accessToken)
  if (data.user) {
    const { user } = data;
    setSessionKey(user);
  } else {
    const user =
      storageSession().getItem<DataInfo<number>>(sessionKey)?.user ?? {};
    setSessionKey(user as any);
  }
}

/** 删除`token`以及key值为`user-info`的session信息 */
export function removeToken() {
  Cookies.remove(TokenKey);
  sessionStorage.clear();
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return token;
};
